var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightboxRight48 = function SvgLightboxRight48(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".lightbox_right_48_svg__st1{display:inline;fill:none;stroke:#000;stroke-width:1.8;stroke-linecap:round;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 1.8,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    d: "M18.7 10.7 32 24 18.4 37.6",
    id: "lightbox_right_48_svg__Layer_2"
  }));
};
export default SvgLightboxRight48;